// extracted by mini-css-extract-plugin
module.exports = {"clamp":"TruncateText_clamp__3vUyP"};